import React, { MouseEventHandler, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { isEmpty, uniqueId, get } from 'lodash';
import VisibilityIcon from '@material-ui/icons/Visibility';
import messages from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/messages';
import { translate } from 'containers/services/translate';
import { CivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import Document from 'components/Document';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import { handleOpenDocument } from 'services/utils';
import SahamAccordion from 'components/SahamAccordion';
import { StyledCivilPartyRecap } from 'containers/common/LegalProceedings/JudgementAdd/Recap/styled-component';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { isMonitoringCourtManager } from 'helpers/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';

export interface CivilPartyRecapProps {
  intl: IntlShape;
  civilParty: CivilParty;
  index: number;
  readOnly?: boolean;
  deleteCivilParty?: MouseEventHandler;
  editCivilParty?: MouseEventHandler;
  resetUploadedDocument?: Function;
  uploadDocument?: Function;
  uploadedDocument?: IUploadedDocument;
  document?: CorporealDocument;
  setDocument?: Function;
  docType?: string;
  docId?: string;
  setDocumentId?: Function;
  creator?: string;
  sagisVictimInfo: any;
  isBasicManagement?: boolean;
  requestGetDocByDocumentumId: Function;
}

const CivilPartyRecap: React.FC<CivilPartyRecapProps> = (
  props,
): JSX.Element => {
  const [expandCivilParty, setExpandedCivilParty] = useState<boolean>(true);

  const handleChangeOnExpandCivilParty = (
    event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    event.stopPropagation();
    setExpandedCivilParty(expanded);
  };

  const { readOnly, deleteCivilParty, civilParty, editCivilParty } = props;
  return (
    <StyledCivilPartyRecap>
      <SahamAccordion
        title={translate(messages.civilPartyRecapTitle, props, {
          number: props.index + 1,
        })}
        expanded={expandCivilParty}
        onChange={handleChangeOnExpandCivilParty}
        deleteButtonTitle={
          !isMonitoringCourtManager() ||
          (currentUserStorage &&
            props.creator === currentUserStorage.get()?.username)
            ? translate(messages.deleteCivilParty, props)
            : undefined
        }
        editButtonTitle={
          !isMonitoringCourtManager() ||
          (currentUserStorage &&
            props.creator === currentUserStorage.get()?.username)
            ? translate(messages.editCivilParty, props)
            : undefined
        }
        deleteButtonOnClick={
          !isMonitoringCourtManager() ||
          (currentUserStorage &&
            props.creator === currentUserStorage.get()?.username)
            ? deleteCivilParty
            : undefined
        }
        editButtonOnClick={
          !isMonitoringCourtManager() ||
          (currentUserStorage &&
            props.creator === currentUserStorage.get()?.username)
            ? editCivilParty
            : undefined
        }
        readOnly={readOnly}
        accordionDetailsClassName="civil-party-content"
      >
        <main>
          <section className="civil_party_select_vicitms">
            <div className="civil-document-recap-sub-title">
              {translate(messages.victims, props)}
            </div>
            <div className="check_box_container">
              {!isEmpty(civilParty) &&
                civilParty.victims.map(victim => (
                  <div key={uniqueId()} className="check_box_div">
                    <span className="victim-name">
                      {featureService.hasFeature(
                        FEATURES.MIGRATION_CLAIM_INFO,
                      ) && !props.isBasicManagement
                        ? `${get(
                            getVictimFromSagisInfo(
                              get(victim, 'victimKey'),
                              props.sagisVictimInfo,
                            ),
                            'victimFirstName',
                            '',
                          )} ${get(
                            getVictimFromSagisInfo(
                              get(victim, 'victimKey'),
                              props.sagisVictimInfo,
                            ),
                            'victimLastName',
                            '',
                          )}`
                        : `${victim.firstName} ${victim.lastName}`}
                    </span>
                  </div>
                ))}
            </div>
          </section>
          <section className="uploaded-civil-doc">
            <div className="civil-document-recap-sub-title">
              {translate(messages.documents, props)}
            </div>
            <Document
              name={civilParty.name}
              type={civilParty.type}
              icon={
                <VisibilityIcon
                  className="consult"
                  onClick={handleOpenDocument(
                    civilParty as any,
                    props.requestGetDocByDocumentumId,
                  )}
                />
              }
            />
          </section>
        </main>
      </SahamAccordion>
    </StyledCivilPartyRecap>
  );
};

export default injectIntl(CivilPartyRecap);
